const REVOKE_DELAY_MS = 60_000;

export const triggerAnchorDownload = (href: string, fileName?: string) => {
  const anchor = document.createElement('a');

  anchor.href = href;
  if (fileName) anchor.download = fileName;
  anchor.rel = 'noopener';
  anchor.style.display = 'none';

  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};

export const triggerBlobDownload = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);

  triggerAnchorDownload(url, fileName);

  setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
};

export const triggerServerDownload = (url: string) => {
  triggerAnchorDownload(url);
};
